import Step1Services from "@/components/booking/Step1Services";
import Step2DateTime from "@/components/booking/Step2DateTime";
import Step3Details from "@/components/booking/Step3Details";
import Step4Review from "@/components/booking/Step4Review";

/**
 * Renders the active wizard step. Extracted from BookingWizard so the
 * parent stays focused on orchestration (state, validation, navigation).
 */
export default function WizardStep({
  step,
  services,
  availability,
  selectedServiceIds,
  setSelectedServiceIds,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  details,
  setDetails,
  errors,
  setErrors,
  onJumpTo,
}) {
  if (step === 1) {
    return (
      <Step1Services
        services={services}
        selected={selectedServiceIds}
        onChange={setSelectedServiceIds}
      />
    );
  }
  if (step === 2) {
    return (
      <Step2DateTime
        serviceIds={selectedServiceIds}
        availability={availability}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        onSelectDate={setSelectedDate}
        onSelectTime={setSelectedTime}
      />
    );
  }
  if (step === 3) {
    return (
      <Step3Details details={details} onChange={setDetails} errors={errors} setErrors={setErrors} />
    );
  }
  return (
    <Step4Review
      services={services}
      selectedServiceIds={selectedServiceIds}
      date={selectedDate}
      time={selectedTime}
      details={details}
      onJumpTo={onJumpTo}
    />
  );
}
